import {Dimensions, StyleSheet} from "react-native";

export const THEME_COLORS = {
    primary: "#242a52",
    primaryPurple:"#7564ef",
    black: "black",
    black2: "#333",
    white: "#fff",
    border1: "#ddd",
    pink:"#ff667a",
    lightPink:"#fff7f0",
    border2: "#eee",
    red: "#ed264f",
    green:"#21cc9e",
    orange:"#ff9a3d",
    red2: "rgb(255,119,119)",
    bgWhite: "#F2F2F2",
    shadow1: "rgba(0, 0, 0, 0.08)",
    disabledInputBG: "#eee",
    shadow2: "rgba(0, 0, 0, 0.5)",
    shadow3: "rgba(0, 0, 0, 0.4)",
    shadow4: "rgba(0, 0, 0, 0.3)",
    grey0: '#adadad',
    grey1: '#e5e5e5',
    grey2:"#f8f7ff",
    selectedPink:"#fff0f0",
    grey3:"#e6e6e6",
    textGrey:"#808080",
    success: "#13b54b",
    redAlert: "#f25278",
    warning: "#fb8c00",
    blackTranslucent: '#000000CC',
    coal: '#303030',
    grey7D: '#7D7D7D',
    greyF9: '#F9F9F9',
    purple: '#6300A3',
    errorRed: '#CD2C39',
    lightPurple: '#C199DA',
    black14: '#141414'
};
export const FONT_FAMILY = {primary: "FuturaPTDemi", secondary: 'NotoSansBold', notosans: 'NotoSans'};
export const FONT_SIZE = {s1: '0.86rem', s2: '0.81rem',s3: '0.78rem', s4: '1rem', logoFontSize: '1.5rem', tabFontSize:  '1.2rem', subTabFontSize: '0.8em'};
export const OTHER_CONSTANTS = {inputHeight: '30px', selectInputHeight: '28px'};
export const symbols = {
    rupee : "₹"
};
export function updateColorWithOpacity(color: string, opacity: number): string {
  const percent = Math.max(0, Math.min(100, opacity * 100)); // bound percent from 0 to 100
  const intValue = Math.round((percent / 100) * 255); // map percent to nearest integer (0 - 255)
  const hexValue = intValue.toString(16); // get hexadecimal representation

  return `${color}${hexValue.padStart(2, '0')?.toUpperCase()}`;
}
// export const FONT_SIZE = {s1: '2.2vh', s2: '2vh'};
// export const OTHER_CONSTANTS = {inputHeight: '4vh', selectInputHeight: '3.9vh'};
export const commonStyles = StyleSheet.create({
    themeColor: {
        backgroundColor: THEME_COLORS.primary,
    },
    loginView: {
        justifyContent: 'center',
        alignItems: 'center',
        height: Dimensions.get('window').height - 200
    },
    inputWidthHeight: {
        minWidth: 400,
        height: 50,
        padding: 5,
        marginTop: 10,
        marginBottom: 10,
    },
    robotoFont: {
        fontFamily: FONT_FAMILY.primary
    },
    input: {
        backgroundColor: THEME_COLORS.white,
        borderRadius: 10,
        borderColor: THEME_COLORS.border1,
        borderWidth: 1,
        shadowColor: THEME_COLORS.shadow1,
        shadowRadius: 4,
        shadowOpacity: 1,
        fontFamily: FONT_FAMILY.primary,
        paddingLeft: 5,
        fontSize: FONT_SIZE.s2,
        height: OTHER_CONSTANTS.inputHeight,
    },
    input2: {
        backgroundColor: THEME_COLORS.white,
        // borderRadius: 25,
        borderBottomColor: THEME_COLORS.border1,
        borderBottomWidth: 1,
        // shadowColor: THEME_COLORS.shadow1,
        // shadowRadius: 4,
        // shadowOpacity: 1,
        fontFamily: FONT_FAMILY.primary,
        paddingLeft: 5,
        fontSize: FONT_SIZE.s2,
        height: OTHER_CONSTANTS.inputHeight,
    },
    disabledInput: {
        backgroundColor: THEME_COLORS.disabledInputBG
    },
    center: {
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: THEME_COLORS.shadow1,
        shadowRadius: 4,
        shadowOpacity: 1,
    },
    actionButton: {
        borderRadius: 10,
        padding: 12,
    },
    actionButtonText: {
        color: THEME_COLORS.white
    },
    cardOne: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: '#EAEAEA',
        padding: 7,
        margin: 10,
        borderRadius: 14,
        shadowColor: 'rgba(119, 119, 119, 1)',
        shadowRadius: 4,
        shadowOpacity: 1,
    },
});

export default commonStyles;